import { render } from "./MenuFolder.vue?vue&type=template&id=0baf8fec&scoped=true"
import script from "./MenuFolder.vue?vue&type=script&lang=js"
export * from "./MenuFolder.vue?vue&type=script&lang=js"

import "./MenuFolder.vue?vue&type=style&index=0&id=0baf8fec&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0baf8fec"]])

export default __exports__